module.exports = __webpack_public_path__ + "img/logintoview.89165ee6.png";